<script lang="ts">
	export let checked: boolean;
	export let disabled: boolean | undefined = undefined;
	export let label: string;
</script>

<div class="form-control my-2">
	<label
		class="flex cursor-pointer items-center"
		class:cursor-not-allowed={disabled}
	>
		<input type="checkbox" class="checkbox" bind:checked {disabled} on:input />
		<span class="label-text ml-2" class:text-info={disabled}>{label}</span>
	</label>
</div>
